import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Loader from './components/common/Loader'

// Chargement différé des pages
const Home = lazy(() => import('./pages/Home'))
const Services = lazy(() => import('./pages/Services'))
const Placements = lazy(() => import('./pages/Placements'))
const Expertise = lazy(() => import('./pages/Expertise'))
const Accompagnement = lazy(() => import('./pages/Accompagnement'))
const Contact = lazy(() => import('./pages/Contact'))
const MentionsLegales = lazy(() => import('./pages/MentionsLegales'))
const PolitiqueConfidentialite = lazy(() => import('./pages/PolitiqueConfidentialite'))
const ConditionsUtilisation = lazy(() => import('./pages/ConditionsUtilisation'))

/**
 * Configuration des routes
 */
const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader fullScreen text="Chargement..." />}>
      <Routes>
        {/* Routes principales */}
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/placements" element={<Placements />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/accompagnement" element={<Accompagnement />} />
        <Route path="/contact" element={<Contact />} />

        {/* Pages légales */}
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/conditions-utilisation" element={<ConditionsUtilisation />} />

        {/* Redirection par défaut */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}

export default AppRoutes